import { BookOpenCheckIcon, FlaskConicalIcon, LayoutGridIcon, LineChartIcon, MessagesSquareIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'Hands-On Climate Science Classroom Experiments & Demos',
    description: 'Printable guides to simple classroom demonstrations that make climate concepts visible.',
    icon: FlaskConicalIcon,
  },
  {
    number: '2',
    title: 'Climate Data & Graph-Reading Worksheets with Answer Keys',
    description: 'Printable worksheets that build students’ skills in reading climate data and graphs, with answer keys.',
    icon: LineChartIcon,
  },
  {
    number: '3',
    title: 'Illustrated Climate Science Glossary & Vocabulary Cards',
    description: 'An illustrated A–Z reference of key climate science terms, plus printable vocabulary cards.',
    icon: BookOpenCheckIcon,
  },
  {
    number: '4',
    title: 'Climate Science Quick-Reference Charts & Diagram Pack',
    description: 'One-page charts and diagrams that summarize core climate concepts for quick review and projection.',
    icon: LayoutGridIcon,
  },
  {
    number: '5',
    title: 'Climate Myths vs Evidence: Classroom Discussion Cards',
    description: 'Printable cards that pair common misconceptions with the evidence, for structured, respectful class discussions.',
    icon: MessagesSquareIcon,
  },
];
